/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyAndPrice
 */
export interface FamilyAndPrice {
    /**
     * 
     * @type {string}
     * @memberof FamilyAndPrice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyAndPrice
     */
    family: string;
    /**
     * 
     * @type {number}
     * @memberof FamilyAndPrice
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof FamilyAndPrice
     */
    meanPrice: number;
    /**
     * 
     * @type {string}
     * @memberof FamilyAndPrice
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyAndPrice
     */
    pictoName?: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyAndPrice
     */
    thumbnailName?: string;
}

/**
 * Check if a given object implements the FamilyAndPrice interface.
 */
export function instanceOfFamilyAndPrice(value: object): value is FamilyAndPrice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('family' in value) || value['family'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('meanPrice' in value) || value['meanPrice'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function FamilyAndPriceFromJSON(json: any): FamilyAndPrice {
    return FamilyAndPriceFromJSONTyped(json, false);
}

export function FamilyAndPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyAndPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'family': json['family'],
        'price': json['price'],
        'meanPrice': json['meanPrice'],
        'url': json['url'],
        'pictoName': json['pictoName'] == null ? undefined : json['pictoName'],
        'thumbnailName': json['thumbnailName'] == null ? undefined : json['thumbnailName'],
    };
}

export function FamilyAndPriceToJSON(value?: FamilyAndPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'family': value['family'],
        'price': value['price'],
        'meanPrice': value['meanPrice'],
        'url': value['url'],
        'pictoName': value['pictoName'],
        'thumbnailName': value['thumbnailName'],
    };
}

